import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
//
import routes from 'router/routes';
import history from 'lib/history';
import ProtectedRoute from 'router/protected-route';
import DashboardPage from 'pages/dashboard';
import DealCreatePage from 'pages/deal-create';
import DealDetailPage from 'pages/deal-detail';
import AuthCallback from 'pages/auth-callback';
import UnauthorizedPage from 'pages/unauthorized';
import OopsPage from 'pages/oops';
import ComparePage from 'pages/compare';
import ParetoPage from 'pages/pareto';
import PortfolioPage from 'pages/portfolio';
import MyBookmarkPage from 'pages/bookmark';
import WhatsNew from 'pages/whatsnew';

// Clear toasts on page changes
history.listen(() => {
  toast.dismiss();
});

const AppRouter = () => (
  <Router history={history}>
    <Switch>
      <Route exact path={routes.authCallback} component={AuthCallback} />
      <Route exact path={routes.unauthorized} component={UnauthorizedPage} />
      <ProtectedRoute exact path={routes.dashboard} component={DashboardPage} />
      <ProtectedRoute exact path={routes.dealCreate} component={DealCreatePage} />
      <ProtectedRoute exact path={routes.dealDetail} component={DealDetailPage} />
      <ProtectedRoute exact path={routes.compare} component={ComparePage} />
      <ProtectedRoute exact path={routes.compareDeals} component={ComparePage} />
      <ProtectedRoute exact path={routes.pareto} component={ParetoPage} />
      <ProtectedRoute exact path={routes.paretoDeals} component={ParetoPage} />
      <ProtectedRoute exact path={routes.portfolio} component={PortfolioPage} />
      <ProtectedRoute exact path={routes.portfolioDeals} component={PortfolioPage} />
      <ProtectedRoute exact path={routes.bookmark} component={MyBookmarkPage} />
      <ProtectedRoute exact path={routes.whatsnew} component={WhatsNew} />
      <Route component={OopsPage} />
    </Switch>
  </Router>
);

export default AppRouter;
